var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntellectual(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Intellectual Property") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M136.468,256.041A133.694,133.694,0,0,1,94.5,153.363c2.372-64.924,53.7-119.5,118.11-127.1a138.234,138.234,0,0,0-23.241-.625C121.827,30.073,66.956,86.183,64.5,153.363a133.694,133.694,0,0,0,41.966,102.678,98.125,98.125,0,0,1,29.173,84.666L134.583,349h30l1.058-8.293A98.125,98.125,0,0,0,136.468,256.041Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 361,
    width: 30,
    height: 32,
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,419.118V405H142v14.118A21.852,21.852,0,0,0,164.157,441h30A21.852,21.852,0,0,1,172,419.118Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.178,433.08c-11.143-7.59-21.549-20.844-28.761-36.364-5.5-11.848-8.417-24.037-8.417-34.325v-108.7l93.968-46.024L334,197.858,220,253.692v108.7c0,10.288,2.912,22.477,8.417,34.325,7.212,15.52,17.618,28.774,28.761,36.364l76.7,52.259,20-13.626Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.224,264.671a85.934,85.934,0,0,1,25.526,74.242l-1.5,11.466a8.663,8.663,0,0,0,7.747,10.2v58.536A33.864,33.864,0,0,0,164.157,453h67.19a34.078,34.078,0,0,0,26.223-11.974l-9.165-7.846A22.2,22.2,0,0,1,231.347,441h-67.19A21.852,21.852,0,0,1,142,419.118V405h81V393H142V361h72V349H134.583l1.058-8.293a98.125,98.125,0,0,0-29.173-84.666A133.694,133.694,0,0,1,64.5,153.363c2.454-67.18,57.325-123.29,124.869-127.724A133.513,133.513,0,0,1,327.4,190.093l11.667,2.808A145.535,145.535,0,0,0,297.581,53.183C268.114,25.354,229.443,11.322,188.635,13.65A145.913,145.913,0,0,0,93.943,57.441,144.45,144.45,0,0,0,60.514,206.586,146.162,146.162,0,0,0,98.224,264.671Z",
    style: {
      fill: "#5b40f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.643,244.729,336.523,185.79a6,6,0,0,0-5.28,0l-120,58.772A5.89,5.89,0,0,0,208,249.948V362.391c0,12.171,3.219,25.79,9.535,39.381,8.1,17.427,20.068,32.453,32.946,41.226l80.05,54.56a5.962,5.962,0,0,0,6.735,0L417.342,443C441.264,426.7,460,391.3,460,362.391V250.116A6,6,0,0,0,456.643,244.729ZM448,362.391c0,24.924-16.786,56.635-37.418,70.69l-76.7,52.258-76.7-52.259c-11.143-7.59-21.549-20.844-28.761-36.364-5.5-11.848-8.417-24.037-8.417-34.325v-108.7l114-55.834,114,56Z",
    style: {
      fill: "#fe9026"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.243,334.083a6,6,0,1,0-8.379,8.59l36.283,35.389a6,6,0,0,0,8.379,0l65.37-63.757a6,6,0,1,0-8.379-8.59l-61.18,59.671Z",
    style: {
      fill: "#fe9026"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntellectual);
export default __webpack_public_path__ + "static/media/intellectual.05a56798757fe91551cfcb8186971925.svg";
export { ForwardRef as ReactComponent };